import { Fragment } from 'react';
import {
  useDataGrid,
  DataGridLoader,
  DataGridTable,
  DataGridTableBody,
  DataGridTableBodyCell,
  DataGridTableBodyRow,
  DataGridTableHead,
  DataGridTableHeadCell,
  DataGridTableEmpty,
  DataGridToolbar,
  CustomColumnMeta,
} from '..'; // Ensure these imports are correct
import {
  flexRender,
  Row,
  Cell,
  HeaderGroup,
  Header,
} from '@tanstack/react-table'; // Use proper generic types

const DataGridInner = <TData extends object>() => {
  const { loading, table } = useDataGrid<TData>(); // type the hook if possible

  return (
    <Fragment>
      <div className="grid min-w-full">
        <div className="scrollable-x-auto" tabIndex={0}>
          <DataGridTable>
            <DataGridTableHead>
              {table
                .getHeaderGroups()
                .map((headerGroup: HeaderGroup<TData>) =>
                  headerGroup.headers.map(
                    (header: Header<TData, unknown>, index) => (
                      <DataGridTableHeadCell key={index} header={header} />
                    )
                  )
                )}
            </DataGridTableHead>
            <DataGridTableBody>
              {table.getRowModel().rows.length > 0 ? (
                table
                  .getRowModel()
                  .rows.map((row: Row<TData>, rowIndex: number) => (
                    <DataGridTableBodyRow key={rowIndex} id={row.id}>
                      {row
                        .getVisibleCells()
                        .map(
                          (cell: Cell<TData, unknown>, cellIndex: number) => (
                            <DataGridTableBodyCell
                              key={cellIndex}
                              id={cell.id}
                              className={
                                (cell.column.columnDef.meta as CustomColumnMeta)
                                  ?.cellClassName || ''
                              }
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </DataGridTableBodyCell>
                          )
                        )}
                    </DataGridTableBodyRow>
                  ))
              ) : (
                <DataGridTableEmpty />
              )}
            </DataGridTableBody>
          </DataGridTable>
          {loading && <DataGridLoader />}
        </div>
        <DataGridToolbar />
      </div>
    </Fragment>
  );
};

export { DataGridInner };
